// extracted by mini-css-extract-plugin
export var assigneeBadge = "_na-0";
export var assigneeDetails = "_na-1";
export var assigneeInfo = "_na-2";
export var dropdownContainer = "_na-4";
export var dropdownImage = "_na-5";
export var editAssigneeInfo = "_na-3";
export var editAssigneeModalContainer = "_na-6";
export var hidden = "_na-8";
export var input = "_na-7";